import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs, useAttrs } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckboxInput',
  props: {
    modelValue: { type: [Boolean, Array, String] },
    disabled: { type: Boolean, default: false },
    color: { default: 'var(--color-blue-800)' },
    rules: { default: () => [] },
    multiple: { type: Boolean, default: false },
    hideDetails: { type: [Boolean, String], default: 'auto' }
  },
  emits: ["update:modelValue", "input", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean | boolean[] | string | string[]): void
  (e: 'input', value: boolean | boolean[] | string | string[]): void
  (e: 'change', value: boolean | boolean[] | string | string[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean | boolean[] | string | string[], disabled: boolean, color: string, rules: unknown[], multiple: boolean, hideDetails: boolean | 'auto' };





const { disabled, color, rules, multiple, hideDetails } = toRefs(props)
const attrs = useAttrs()

const value = computed({
  get: () => props.modelValue,
  set: (val) => {
    emit('update:modelValue', val)
    emit('input', val)
    emit('change', val)
  },
})

return { __sfc: true,props, emit, disabled, color, rules, multiple, hideDetails, attrs, value }
}

})